<template>
  <div class="interview" data-scroll-container>
    <TheHeader />
    <InterviewMV />
    <Profile :data="profile" />
    <MovieSection :openModal="openModal" posterImage="poster-mizutamari.png" />
    <Contents />
    <Product />
    <InterviewList :type="`interview`" :list="['tokido', 'mishina']" />
    <Credit />
    <TheFooter />
    <MovieModal
      :isModalOpen="isModalOpen"
      :closeModal="closeModal"
      movieFileName="mizutamari.mp4"
      posterImage="poster-mizutamari.png"
    />
  </div>
</template>

<script>
import imagesLoaded from 'imagesloaded'

import InterviewMV from '@/components/interview/InterviewMV.vue'
import Profile from '@/components/interview/Profile.vue'
import Contents from '@/components/interview/Contents.vue'

import MovieSection from '@/components/interview/MovieSection.vue'
import InterviewList from '@/components/InterviewList.vue'

import Credit from '@/components/Credit.vue'
import Product from '@/components/Product.vue'

import MovieModal from '@/components/interview/MovieModal.vue'

/* global */
import TheHeader from '@/components/TheHeader.vue'
import TheFooter from '@/components/TheFooter.vue'

/* mixin */
import locomotive from '@/mixins/locomotive.js'
export default {
  mixins: [locomotive],

  metaInfo() {
    return {
      title: '水溜りボンド スペシャルインタビュー',
      meta: [
        {
          property: 'og:title',
          content: '水溜りボンド スペシャルインタビュー | OCEANTRICO JET'
        },
        {
          name: 'description',
          content:
            'OCEAN TRICO史上、"最強"のハードワックスとして登場したJET。10月に解禁されたビジュアルでは、いまもっとも勢いをもって活躍する3組のプロフェッショナルをモデルとして起用した。彼らは日々、ハードな環境と向き合いながら、“最強”であり続けている。その裏側では、絶え間なき努力や葛藤があったはずだ。このスペシャルインタビューでは、そういった彼らの内面に向き合いながら、彼らが“最強”であり続ける所以を紐解いていく。'
        },
        {
          property: 'og:description',
          content:
            'OCEAN TRICO史上、"最強"のハードワックスとして登場したJET。10月に解禁されたビジュアルでは、いまもっとも勢いをもって活躍する3組のプロフェッショナルをモデルとして起用した。彼らは日々、ハードな環境と向き合いながら、“最強”であり続けている。その裏側では、絶え間なき努力や葛藤があったはずだ。このスペシャルインタビューでは、そういった彼らの内面に向き合いながら、彼らが“最強”であり続ける所以を紐解いていく。'
        },
        {
          property: 'og:image',
          content: `https://oceantrico.com/jet/share/ogp-mizutamari.jpg`
        },
        {
          name: 'twitter:image',
          content: `https://oceantrico.com/jet/share/ogp-mizutamari.jpg`
        }
      ]
    }
  },

  components: {
    TheHeader,
    InterviewMV,
    Profile,
    Contents,
    MovieSection,
    InterviewList,
    Credit,
    Product,
    MovieModal,
    TheFooter
  },

  data() {
    return {
      isModalOpen: false,
      profile: {
        slug: 'mizutamari',
        name: '水溜りボンド',
        desc:
          'カンタとトミーによる二人組動画クリエイター。 ドッキリ、検証、料理、実験、都市伝説など、視聴者の皆さんに楽しんでいただけるように、 2015年1月1日の活動開始以来、一日も欠かさず毎日動画投稿している。 冠ラジオ番組やテレビ番組、雑誌の連載などYouTube以外でも活躍している。'
      }
    }
  },

  mounted() {
    const { commit } = this.$store

    this.$nextTick(() => {
      const firstViewImgLoad = new imagesLoaded(
        this.$el.querySelector('.js-first-view')
      )
      firstViewImgLoad.on('always', () => {
        commit('loaded')
      })

      const imgLoad = new imagesLoaded(this.$el)
      imgLoad.on('always', () => {
        if (window.lmS) window.lmS.update()

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const color = entry.target.getAttribute('data-logo-color')
                commit('logoColorChange', color)
              } else {
                commit('logoColorChange', 'white')
              }
            })
          },
          { threshold: [0.2, 0.7] }
        )

        document.querySelectorAll('.js-color-change').forEach((el) => {
          this.observer.observe(el)
        })
        // commit('loaded')
      })
    })
  },

  methods: {
    onHomeClick() {
      this.$router.push('/')
    },

    openModal() {
      this.isModalOpen = true
    },

    closeModal() {
      this.isModalOpen = false
    }
  },

  beforeDestroy() {
    document.querySelectorAll('.js-color-change').forEach((el) => {
      this.observer.unobserve(el)
    })
  }
}
</script>

<style lang="scss" scoped>
.interview {
  width: 100%;
}
</style>
